import { Locale } from 'modules/i18n';

export const codeExampleMenuItemTranslation = {
  [Locale.en]: {
    codeExample: 'Code example',
  },
};
